const prevArrow = `<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg viewBox="0 0 123 123">
${$('#icon-prev')[0].innerHTML}</svg></button>`;
const nextArrow = `<button class="slick-next slick-arrow" aria-label="Next" type="button">
<svg viewBox="0 0 123 123">${$('#icon-next')[0].innerHTML}</svg></button>`;

const slickDefault = {
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  arrows: true,
  prevArrow,
  nextArrow,
  adaptiveHeight: true,
};

const gallerySlider = () => {
  const sliderGallery = $('.js-slider-gallery')
  const sliderMain = sliderGallery.find('.block-slider-gallery__list--main')
  sliderMain.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    dots: true,
    arrows: true,
    prevArrow,
    nextArrow,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 3,
        }
      }
    ]
  })

}


export const slickInit = () => {
  $('.js-slider').slick(slickDefault);

  gallerySlider();
};



// WEBPACK FOOTER //
// ./wp/wp-content/themes/ukrainian-museum-theme/src/scripts/modules/slick.js